import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import SummaryBox from "./summaryBox";
import { useTranslation } from "react-i18next";
import companyData from '../../../assets/data/company.json';
import projectData from '../../../assets/data/projects.json';
import IconComponent from "../../../components/icons/IconComponent";
import StarIcon from '../../../assets/icons/star.svg';
import './summary.css';
import { useCallback } from "react";

const SummaryLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const getStarSize = useCallback(() => {
        if(isLgUp) return 40;

        if(isMdUp) return 24;

        return 24;
    }, [isLgUp, isMdUp]);

    const getProjectCount = useCallback(() => {
        let count = 10; // Offset

        count += projectData.ai.length;
        count += projectData.web.length;
        count += projectData.mobile.length;
        count += projectData.games.length;

        return count;

    }, [projectData]);

    return (
        <>
            <Box
                className="sectionMarginSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.primary.main
                }}
            >
                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    sx={{
                        px: '5%'
                    }}
                >
                    <Grid size={{xs: 6, md: 3}}>
                        <SummaryBox 
                            value={getProjectCount()} 
                            description={t('summary.projects')}
                            suffixValue="+"
                            alignItems={{xs: "center", md: "start"}}
                            direction="column-reverse"
                            hightLight
                        />
                    </Grid>

                    <Grid size={{xs: 6, md: 3}}>
                        <SummaryBox 
                            value={companyData.reach.countries.length}
                            description={t('summary.countries')}
                        />
                    </Grid>

                    <Grid size={{xs: 6, md: 3}}>
                        <SummaryBox 
                            value={companyData.reach.industries.length}
                            description={t('summary.industries')}
                            suffixValue="+"
                        />
                    </Grid>

                    <Grid 
                        size={{xs: 6, md: 3}}
                        sx={{
                            border: {xs: `2px solid white`, md: 'none'}
                        }}
                    >
                        <SummaryBox 
                            value={companyData.summary.rating}
                            description={t('summary.rating')}
                            suffixIcon={
                                <IconComponent 
                                    icon={StarIcon}
                                    alt="Star"
                                    size={getStarSize()}
                                    style={{
                                        animation: 'rotation 7s infinite linear',
                                        transformOrigin: 'center center'
                                    }}
                                />
                            }
                            alignItems={{xs: "center", md: "end"}}
                            stopCountUp={true}
                            hidePrefixZero={true}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default SummaryLayout;